import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=3b368b47&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=3b368b47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b368b47",
  null
  
)

export default component.exports